import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { PrivateRoute } from '../../../../utils/route-auth';
import { PERMISSION } from '../../../../constants/permission';
import asyncRoute from '../../../../helpers/hoc/asyncRoute';
import routes from '../../../../routes';

// Import your view components
const AgencyView = asyncRoute(() => import('./AgencyView'));
const AdvertiserView = asyncRoute(() => import('./AdvertiserView'));
const InfomoView = asyncRoute(() => import('./InfomoView'));

const Views = (props) => {
    let userType = '';
    const tenantId = useSelector((state) => state && state.app && state.app.preSignInState ? state.app.preSignInState.tenantId : "");
    const preSignInData = useSelector((state) => state && state.app && state.app.preSignInData ? state.app.preSignInData.responseList : "");
    const isSigningIn = localStorage.getItem('isSigningIn');

    if (preSignInData && preSignInData.length > 0) {
        preSignInData.forEach(item => {
            if (item.tenantId === tenantId) {
                userType = item.tenantType.toLowerCase();
            }
        })
    };

    if (Number(isSigningIn)) {
        userType = '';
    }


    const getMainComponent = () => {
        switch (userType) {
            case 'advertiser':
            case 'demo advertiser':
                return AdvertiserView;
            case 'dsp/ad network':
                return AgencyView;
            case 'platform manager':
                return InfomoView;
            default:
                return <React.Fragment></React.Fragment>;
        }
    };

    return (
        <>
            {
                userType !== '' &&
                <Switch>
                    <Route exact path={`${props.match.path}`} component={getMainComponent()} />
                </Switch>
            }
        </>
    )
};


export default Views;
